import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type Type = "bus" | "people";

interface IState {
  visible: boolean;
  eventTypes: any[];
  markerMode: SelectingType[];
  pointwiseShow: boolean;
  loading: boolean;
  type: Type;
  selectedCamera: any[];
  eventStarTypes: any[];
}

const initialState: IState = {
  visible: false,
  eventTypes: [],
  markerMode: ["source"],
  pointwiseShow: false,
  loading: false,
  type: "people",
  selectedCamera: [],
  eventStarTypes: [],
};

export const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    changeEventType: (state, action: PayloadAction<any>) => {
      if (state.eventTypes.includes(action.payload)) {
        return { ...state, eventTypes: state.eventTypes.filter((c) => c !== action.payload) };
      }
      return { ...state, eventTypes: [...state.eventTypes, action.payload] };
    },
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
    togglePointwiseShow: (state) => {
      return { ...state, pointwiseShow: !state.pointwiseShow };
    },
    changeLoadingMode: (state, action: PayloadAction<boolean>) => {
      return { ...state, loading: action.payload };
    },
    selectCamera: (state, action: PayloadAction<any[]>) => {
      return { ...state, selectedCamera: action.payload };
    },
    changeEventStarTypes: (state, action: PayloadAction<any[]>) => {
      return { ...state, eventStarTypes: action.payload };
    },
  },
});

export const {
  changeEventType,
  toggleVisibility,
  makeInvisible,
  togglePointwiseShow,
  changeLoadingMode,
  selectCamera,
  changeEventStarTypes,
} = eventSlice.actions;

export default eventSlice.reducer;
